var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicalTrackingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00048 7.66295C1.04386 11.3621 7.63455 19.1618 7.63455 19.1618C7.63455 19.1618 14.0432 11.4324 13.9998 7.73321C13.971 5.28102 12.6671 3.12969 10.7456 1.95229C9.76846 1.35358 8.63164 1.0067 7.4216 1.00016C3.83195 0.980751 0.95711 3.96379 1.00048 7.66295Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1763 7.7058C10.1584 6.17486 8.94573 4.92727 7.46766 4.91924C7.21162 4.91784 6.9644 4.95374 6.73074 5.02201C5.61554 5.34783 4.80896 6.41098 4.82373 7.67671C4.82903 8.13144 4.93975 8.56117 5.13153 8.94085C5.5854 9.83943 6.4933 10.4576 7.53234 10.4633C9.0104 10.4713 10.1941 9.23673 10.1763 7.7058Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00048 7.66288C1.04386 11.362 7.63455 19.1618 7.63455 19.1618C7.63455 19.1618 14.0432 11.4323 13.9998 7.73315C13.971 5.28096 12.6671 3.12963 10.7456 1.95223C9.76846 1.35351 8.63164 1.00664 7.4216 1.00009C3.83195 0.98069 0.95711 3.96373 1.00048 7.66288Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1763 7.70574C10.1584 6.1748 8.94573 4.92721 7.46766 4.91917C7.21162 4.91778 6.9644 4.95368 6.73074 5.02195C5.61554 5.34777 4.80896 6.41092 4.82373 7.67665C4.82903 8.13138 4.93975 8.56111 5.13153 8.94078C5.5854 9.83936 6.4933 10.4576 7.53234 10.4632C9.0104 10.4712 10.1941 9.23667 10.1763 7.70574Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicalTrackingIcon);
export default __webpack_public_path__ + "static/media/vehicalTrackingIcon.3fb9e8e1f2ebd6828f34f13210396114.svg";
export { ForwardRef as ReactComponent };